import React from 'react';
import FooterSettings from '../components/FooterSettings';

const Footer = () => {
  return <FooterSettings />;
};

export default Footer; 